import { isFiveAppBrowser, presentModal } from '@el5/native-api'
import { FC } from 'react'

import { StatusCard } from './StatusCard'
import { INoCardPromptProps } from './types'
import { useCardPolling } from './useCardPolling'

const baseLoyaltyIssueUrl = isFiveAppBrowser()
  ? import.meta.env.VITE_HOMEPAGE_URL
  : import.meta.env.VITE_PEREKRESTOK_URL

const loyaltyIssueUrl = `${baseLoyaltyIssueUrl}/loyalty/issue`

export const NoCardPrompt: FC<INoCardPromptProps> = ({ isLoading = false }) => {
  const { startPolling } = useCardPolling()

  const onGetCard = async () => {
    presentModal(loyaltyIssueUrl)
    startPolling()
  }

  return (
    <StatusCard
      title="Нет карты"
      description="Карта нужна, чтобы начислить баллы лояльности за выполненные задания"
      buttonText="Выпустить карту"
      onButtonClick={onGetCard}
      isButtonDisabled={isLoading}
    />
  )
}
